/*
  LANDING MADE IN ITALY + PROMO — l'offerta.

  Una sola scelta per tutta la pagina: la sezione dopo il confronto e quella
  ripetuta in fondo leggono e scrivono lo stesso stato, e la barra fissa ci si
  appoggia. Per questo lo stato sta qui fuori e non dentro l'istanza.

  26/09/2026 — SI SCELGONO TUTTE E DUE LE BORSE.
  Prima la principale era fissa: chi voleva partire da un altro modello non
  aveva modo di farlo. Adesso ci sono due gallerie, la stessa lista per
  entrambe, e ognuna esclude la borsa gia' scelta nell'altra. La borsa
  impostata nella sezione resta quella preselezionata, quindi chi non tocca
  niente vede esattamente quello che vedeva prima.

  IL PREZZO
  prezziCoppia() e' l'unico punto in cui si decide chi prende lo sconto. La
  regola di oggi ('second_half') e' quella dello sconto automatico gia' attivo
  sul negozio: il 50% va alla borsa MENO CARA della coppia, a parita' alla
  seconda. La pagina non applica nulla: mostra quello che il carrello fara'.
  Quando arrivera' la landing "2 borse a 199" bastera' aggiungere un ramo qui.
*/
(function () {
  'use strict';

  var stato = {
    opzione: 'coppia',   /* 'sola' | 'coppia' */
    principale: null,
    seconda: null,
    terza: null,      /* 21/10/2026 — Black Friday, opzione 'tris' */
    omaggio: null,    /* la borsa in omaggio con tre borse (colore scelto) */
    filtro: '',
    totale: 0
  };
  var istanze = [];

  function euro(centesimi) {
    return '€' + (centesimi / 100).toFixed(2).replace('.', ',');
  }

  function prezziCoppia(principale, seconda, modo, fisso) {
    /* 15/10/2026 — "pair_price": due borse a prezzo fisso (promo Halloween,
       199 €). Il prezzo arriva dalle impostazioni del tema (data-prezzo-coppia):
       ciascuna riga mostra meta' della cifra; se le due costano gia' meno,
       nessuno sconto. */
    if (modo === 'pair_price' && seconda && fisso) {
      var somma = principale.prezzo + seconda.prezzo;
      if (somma <= fisso) return {prima: principale.prezzo, seconda: seconda.prezzo, sconto: 0, scontaPrincipale: false};
      var meta = Math.floor(fisso / 2);
      return {prima: meta, seconda: fisso - meta, sconto: somma - fisso, scontaPrincipale: false};
    }
    if (modo !== 'second_half' || !seconda) {
      return {prima: principale.prezzo, seconda: 0, sconto: 0, scontaPrincipale: false};
    }
    var menoCara = Math.min(principale.prezzo, seconda.prezzo);
    var sconto = Math.round(menoCara / 2);
    /* A parita' di prezzo lo sconto va alla seconda: stessa scelta del modulo
       che gira sulle schede prodotto, cosi' i due posti non si contraddicono. */
    var scontaPrincipale = principale.prezzo < seconda.prezzo;
    return {
      prima: scontaPrincipale ? principale.prezzo - sconto : principale.prezzo,
      seconda: scontaPrincipale ? seconda.prezzo : seconda.prezzo - sconto,
      sconto: sconto,
      scontaPrincipale: scontaPrincipale
    };
  }

  function annuncia() {
    document.dispatchEvent(new CustomEvent('vxmip:stato', {detail: {
      opzione: stato.opzione,
      principale: stato.principale,
      seconda: stato.seconda,
      totale: stato.totale
    }}));
  }

  function prepara(sezione) {
    if (sezione.dataset.vxofPronta === '1') return;
    sezione.dataset.vxofPronta = '1';

    var dati;
    try { dati = JSON.parse(sezione.querySelector('[data-vxof-dati]').textContent); }
    catch (e) { return; }
    if (!dati || !dati.candidate || !dati.candidate.length) return;

    var modo = sezione.getAttribute('data-pricing') || 'second_half';
    var fisso = parseInt(sezione.getAttribute('data-prezzo-coppia'), 10) || 0;
    var TRIS = parseInt(sezione.getAttribute('data-prezzo-tris'), 10) || 0;
    var etichettaSconto = sezione.getAttribute('data-etichetta') || 'La paghi la metà';
    var compatta = sezione.getAttribute('data-layout') === 'compact';
    /* 27/10/2026 — le scritte del modulo vengono dall'editor (data-t-*);
       se mancano restano quelle di sempre. */
    function testo(k, d) { var v = sezione.getAttribute('data-t-' + k); return v ? v : d; }

    var ops    = sezione.querySelectorAll('[data-vxof-op]');
    var blocco = sezione.querySelector('[data-vxof-scelta]');
    var passo2 = sezione.querySelector('[data-vxof-passo2]');
    var compra = sezione.querySelector('[data-vxof-compra]');
    var errore = sezione.querySelector('[data-vxof-errore]');
    var testoCompra = compra ? compra.textContent.trim() : "Completa l'ordine";

    /* L'ordine segue la classifica dei piu' venduti; chi non e' in classifica
       va in fondo, nell'ordine della collezione. */
    var posizione = {};
    (dati.classifica || []).forEach(function (id, i) { posizione[id] = i; });
    var candidate = dati.candidate.slice().sort(function (a, b) {
      var pa = posizione[a.id], pb = posizione[b.id];
      if (pa === undefined && pb === undefined) return 0;
      if (pa === undefined) return 1;
      if (pb === undefined) return -1;
      return pa - pb;
    });

    if (!stato.principale) {
      stato.principale = candidate.filter(function (c) { return c.id === dati.predefinita; })[0]
        || candidate.filter(function (c) { return c.disp; })[0] || null;
    }
    /* 16/10/2026 — UNA SOLA LIMITED EDITION PER COPPIA nella promo a prezzo
       fisso (199 €): due Limited Edition non lasciano margine e lo sconto
       (app voemien-sconti) non le accoppia. Scelta una Limited Edition,
       dall'altra galleria spariscono le altre. Con la seconda al 50% non vale. */
    function eLimited(c) { return /limited\s+edition/i.test((c && c.titolo) || ''); }
    function insieme(a, b) { return modo !== 'pair_price' || !(eLimited(a) && eLimited(b)); }
    function primaSeconda() {
      return candidate.filter(function (c) {
        return c.disp && (!stato.principale || c.id !== stato.principale.id) && insieme(stato.principale, c);
      })[0] || null;
    }
    /* 21/10/2026 — con «Tre borse» vale lo stesso limite su tutte e tre:
       al massimo una Limited Edition. compatibile() guarda le borse gia'
       scelte negli ALTRI posti dell'opzione attiva. */
    function compatibile(tipo, c) {
      if (modo !== 'pair_price' || !eLimited(c)) return true;
      var altre = [];
      if (tipo !== 'principale') altre.push(stato.principale);
      if (tipo !== 'seconda' && (stato.opzione === 'coppia' || stato.opzione === 'tris')) altre.push(stato.seconda);
      if (tipo !== 'terza' && stato.opzione === 'tris') altre.push(stato.terza);
      return !altre.some(eLimited);
    }
    function primaPer(tipo) {
      return candidate.filter(function (c) { return c.disp && compatibile(tipo, c); })[0] || null;
    }
    if (stato.seconda && !insieme(stato.principale, stato.seconda)) stato.seconda = null;
    if (!stato.seconda) {
      stato.seconda = candidate.filter(function (c) {
        return c.disp && (!stato.principale || c.id !== stato.principale.id) && insieme(stato.principale, c);
      })[0] || null;
    }

    if (TRIS && !stato.terza) {
      stato.terza = candidate.filter(function (c) {
        return c.disp && !eLimited(c) &&
          (!stato.principale || c.id !== stato.principale.id) &&
          (!stato.seconda || c.id !== stato.seconda.id);
      })[0] || null;
    }

    /* La borsa in omaggio: pulsanti colore nel riepilogo. Lo stato e' unico
       per le due copie della sezione, come le borse. */
    var colori = [].slice.call(sezione.querySelectorAll('[data-vxof-colore]')).map(function (el) {
      return {el: el, id: el.getAttribute('data-vxof-colore'), titolo: el.getAttribute('data-titolo') || '',
              img: el.getAttribute('data-img') || '', prezzo: parseInt(el.getAttribute('data-prezzo'), 10) || 0,
              disp: !el.disabled};
    });
    if (!stato.omaggio) {
      stato.omaggio = colori.filter(function (c) { return c.disp && c.el.getAttribute('aria-checked') === 'true'; })[0]
        || colori.filter(function (c) { return c.disp; })[0] || null;
    }
    colori.forEach(function (c) {
      c.el.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!c.disp) return;
        stato.omaggio = c;
        stato.opzione = 'tris';
        tuttiAggiornano();
      });
    });

    /* Il conto delle tre borse, con la STESSA regola dell'app voemien-sconti
       (vedi anche il modulo delle schede, vx-offerta-2borse-script): gruppo da
       tre a TRIS se costano almeno tanto e c'e' al massimo una Limited
       Edition; se no la combinazione migliore fra coppia + una, o nessuno
       sconto. Il valore dell'omaggio conta nel confronto; a parita' vince il
       gruppo da tre. */
    function contoTris() {
      if (!TRIS || !stato.principale || !stato.seconda || !stato.terza) return null;
      var pz = [stato.principale, stato.seconda, stato.terza].map(function (b) {
        return {prezzo: b.prezzo, lim: eLimited(b)};
      });
      var somma = pz[0].prezzo + pz[1].prezzo + pz[2].prezzo;
      var lim = pz.filter(function (x) { return x.lim; }).length;
      var tris = lim <= 1 && somma >= TRIS ? TRIS - (stato.omaggio ? stato.omaggio.prezzo : 0) : Infinity;
      var altro = somma;
      if (fisso) {
        [[0, 1, 2], [0, 2, 1], [1, 2, 0]].forEach(function (k) {
          var a = pz[k[0]], b = pz[k[1]];
          if ((a.lim && b.lim) || a.prezzo + b.prezzo <= fisso) return;
          altro = Math.min(altro, fisso + pz[k[2]].prezzo);
        });
      }
      if (tris <= altro) {
        var base = Math.floor(TRIS / 3), resto = TRIS - base * 3;
        return {totale: TRIS, omaggio: true, prezzi: [base + (resto > 0 ? 1 : 0), base + (resto > 1 ? 1 : 0), base]};
      }
      return {totale: altro, omaggio: false, prezzi: null};
    }

    /* ---------------- le gallerie ---------------- */
    function disegnaPista(tipo) {
      var pista = sezione.querySelector('[data-vxof-pista="' + tipo + '"]');
      if (!pista) return;
      var esclusa = tipo === 'principale' ? stato.seconda : stato.principale;
      var scelta  = tipo === 'principale' ? stato.principale : (tipo === 'terza' ? stato.terza : stato.seconda);
      pista.innerHTML = '';
      candidate
        /* 20/10/2026 — due borse uguali sono una coppia valida (lo sconto le
           accoppia): la borsa scelta nell'altra galleria non si toglie piu'.
           Resta il limite di una Limited Edition per coppia. */
        .filter(function (c) { return compatibile(tipo, c); })
        .filter(function (c) { return !stato.filtro || (c.materiale || '') === stato.filtro; })
        .forEach(function (c) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'vxof__card';
          b.setAttribute('role', 'radio');
          b.setAttribute('aria-checked', scelta && scelta.id === c.id ? 'true' : 'false');
          if (!c.disp) b.setAttribute('disabled', 'true');
          b.innerHTML =
            '<span class="vxof__cardfoto">' +
              '<img src="' + (c.img || '') + '" alt="" width="168" height="168" loading="lazy" decoding="async">' +
              '<span class="vxof__cardspunta" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6L9 17l-5-5"/></svg></span>' +
            '</span>' +
            '<span class="vxof__cardnome">' + c.titolo + '</span>' +
            '<span class="vxof__cardmat">' + [c.materiale, c.colore].filter(Boolean).join(' · ') + '</span>' +
            '<span class="vxof__cardprezzo">' + euro(c.prezzo) + '</span>';
          b.addEventListener('click', function () {
            if (!c.disp) return;
            if (tipo === 'principale') {
              stato.principale = c;
              if (stato.seconda && !insieme(c, stato.seconda)) stato.seconda = primaSeconda();
            } else if (tipo === 'seconda') {
              stato.seconda = c;
              if (stato.opzione !== 'tris') stato.opzione = 'coppia';
            } else {
              stato.terza = c;
              stato.opzione = 'tris';
            }
            /* Una Limited Edition appena scelta puo' rendere incompatibile la
               terza: la si sostituisce con la prima compatibile. */
            if (stato.opzione === 'tris' && stato.terza && !compatibile('terza', stato.terza)) stato.terza = primaPer('terza');
            tuttiAggiornano();
            apriScheda(c);
          });
          pista.appendChild(b);
        });
    }

    function disegna() { disegnaPista('principale'); disegnaPista('seconda'); disegnaPista('terza'); }

    [].forEach.call(sezione.querySelectorAll('[data-vxof-chip]'), function (chip) {
      chip.addEventListener('click', function () {
        stato.filtro = chip.getAttribute('data-vxof-chip') || '';
        tuttiAggiornano();
      });
    });

    ['principale', 'seconda'].forEach(function (tipo) {
      var pista = sezione.querySelector('[data-vxof-pista="' + tipo + '"]');
      var prec  = sezione.querySelector('[data-vxof-prec="' + tipo + '"]');
      var succ  = sezione.querySelector('[data-vxof-succ="' + tipo + '"]');
      if (prec && pista) prec.addEventListener('click', function () { pista.scrollBy({left: -360, behavior: 'smooth'}); });
      if (succ && pista) succ.addEventListener('click', function () { pista.scrollBy({left: 360, behavior: 'smooth'}); });
    });

    [].forEach.call(ops, function (op) {
      function scegli() {
        stato.opzione = op.getAttribute('data-vxof-op');
        tuttiAggiornano();
      }
      op.addEventListener('click', scegli);
      op.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); scegli(); }
      });
    });

    /* ---------------- il riepilogo ---------------- */
    function aggiorna() {
      var p = stato.principale;
      if (!p) return;
      var coppia = stato.opzione === 'coppia' && stato.seconda;
      var tris = stato.opzione === 'tris' ? contoTris() : null;
      var calc = coppia ? prezziCoppia(p, stato.seconda, modo, fisso)
                        : {prima: p.prezzo, seconda: 0, sconto: 0, scontaPrincipale: false};
      if (tris) {
        calc = tris.prezzi
          ? {prima: tris.prezzi[0], seconda: tris.prezzi[1], terza: tris.prezzi[2]}
          : {prima: p.prezzo, seconda: stato.seconda.prezzo, terza: stato.terza.prezzo};
      }

      [].forEach.call(ops, function (op) {
        var attiva = op.getAttribute('data-vxof-op') === stato.opzione;
        op.setAttribute('aria-checked', attiva ? 'true' : 'false');
        op.setAttribute('tabindex', attiva ? '0' : '-1');
      });

      function scrivi(sel, testo) {
        var el = sezione.querySelector(sel);
        if (el) el.textContent = testo || '';
      }

      scrivi('[data-vxof-op1nome]', p.titolo);
      scrivi('[data-vxof-p1]', euro(p.prezzo));
      scrivi('[data-vxof-b1]', p.listino > p.prezzo ? euro(p.listino) : '');

      if (stato.seconda) {
        var c2 = prezziCoppia(p, stato.seconda, modo, fisso);
        var pieno = p.prezzo + stato.seconda.prezzo;
        scrivi('[data-vxof-p2]', euro(c2.prima + c2.seconda));
        scrivi('[data-vxof-b2]', euro(pieno));
        scrivi('[data-vxof-risparmio]', testo('risparmi', 'Risparmi') + ' ' + euro(c2.sconto));
      } else {
        scrivi('[data-vxof-p2]', '—');
        scrivi('[data-vxof-b2]', '');
        scrivi('[data-vxof-risparmio]', '');
      }

      /* Prezzo dell'opzione «Tre borse» nella sua card: il conto con le borse
         scelte (anche se l'opzione attiva e' un'altra). */
      var c3 = contoTris();
      scrivi('[data-vxof-p3]', c3 ? euro(c3.totale) : (TRIS ? euro(TRIS) : ''));
      if (c3) {
        var pieno3 = stato.principale.prezzo + stato.seconda.prezzo + stato.terza.prezzo
          + (c3.omaggio && stato.omaggio ? stato.omaggio.prezzo : 0);
        scrivi('[data-vxof-b3]', euro(pieno3));
        scrivi('[data-vxof-risparmio3]', testo('risparmi', 'Risparmi') + ' ' + euro(pieno3 - c3.totale));
      }

      if (blocco) blocco.hidden = compatta;
      if (passo2) passo2.hidden = stato.opzione !== 'coppia' && stato.opzione !== 'tris';
      var passo3 = sezione.querySelector('[data-vxof-passo3]');
      if (passo3) passo3.hidden = stato.opzione !== 'tris';

      var mini1 = sezione.querySelector('[data-vxof-mini1]');
      if (mini1) mini1.src = p.img || '';
      scrivi('[data-vxof-nome1]', p.titolo);
      scrivi('[data-vxof-r1]', euro(calc.prima));
      var etichettaTris = TRIS ? ' · ' + testo('tris', 'tre borse a') + ' ' + Math.round(TRIS / 100) + ' €' : '';
      scrivi('[data-vxof-meta1]', tris && tris.omaggio ? etichettaTris : (coppia && calc.scontaPrincipale ? ' · ' + etichettaSconto : ''));

      var riga2 = sezione.querySelector('[data-vxof-riga2]');
      if (riga2) {
        riga2.hidden = !(coppia || tris);
        if (coppia || tris) {
          var mini2 = sezione.querySelector('[data-vxof-mini2]');
          if (mini2) mini2.src = stato.seconda.img || '';
          scrivi('[data-vxof-nome2]', stato.seconda.titolo);
          scrivi('[data-vxof-meta2]', tris ? (tris.omaggio ? etichettaTris : '') : (calc.scontaPrincipale ? '' : ' · ' + etichettaSconto));
          scrivi('[data-vxof-r2]', euro(calc.seconda));
        }
      }
      var riga3 = sezione.querySelector('[data-vxof-riga3]');
      if (riga3) {
        riga3.hidden = !tris;
        if (tris) {
          var mini3 = sezione.querySelector('[data-vxof-mini3]');
          if (mini3) mini3.src = stato.terza.img || '';
          scrivi('[data-vxof-nome3]', stato.terza.titolo);
          scrivi('[data-vxof-meta3]', tris.omaggio ? etichettaTris : '');
          scrivi('[data-vxof-r3]', euro(calc.terza));
        }
      }
      var rigaOm = sezione.querySelector('[data-vxof-rigaom]');
      if (rigaOm) {
        rigaOm.hidden = !tris;
        if (tris && stato.omaggio) {
          var miniOm = sezione.querySelector('[data-vxof-miniom]');
          if (miniOm) miniOm.src = stato.omaggio.img;
          scrivi('[data-vxof-nomeom]', stato.omaggio.titolo);
          /* Caso raro: con queste tre borse l'app non fa il gruppo da tre. */
          scrivi('[data-vxof-rom]', tris.omaggio ? testo('gratis', 'Gratis') : testo('noninc', 'Non incluso'));
        }
        [].forEach.call(sezione.querySelectorAll('[data-vxof-colore]'), function (b) {
          b.setAttribute('aria-checked', stato.omaggio && b.getAttribute('data-vxof-colore') === stato.omaggio.id ? 'true' : 'false');
        });
      }

      var totale = tris ? tris.totale : calc.prima + (coppia ? calc.seconda : 0);
      stato.totale = totale;
      scrivi('[data-vxof-totale]', euro(totale));
      var pienoTot = tris
        ? stato.principale.prezzo + stato.seconda.prezzo + stato.terza.prezzo + (tris.omaggio && stato.omaggio ? stato.omaggio.prezzo : 0)
        : p.prezzo + (coppia ? stato.seconda.prezzo : 0);
      scrivi('[data-vxof-totalebar]', pienoTot > totale ? euro(pienoTot) : '');

      if (compra) compra.textContent = testoCompra + ' · ' + euro(totale);

      [].forEach.call(sezione.querySelectorAll('[data-vxof-chip]'), function (chip) {
        chip.setAttribute('aria-pressed', (chip.getAttribute('data-vxof-chip') || '') === stato.filtro ? 'true' : 'false');
      });
    }

    /* ---------------- la scheda rapida ----------------
       Chi sceglie una borsa la vede da vicino senza uscire dalla pagina:
       foto, prezzo e descrizione arrivano da /products/<handle>.js, chiesti
       solo al primo bisogno e poi tenuti da parte. Se la chiamata non va a
       buon fine si mostra comunque quello che sappiamo gia' (foto piccola,
       nome e prezzo) invece di aprire un riquadro vuoto. */
    var qv       = sezione.querySelector('[data-vxof-qv]');
    var qvCorpo  = sezione.querySelector('[data-vxof-qvcorpo]');
    var qvOk     = sezione.querySelector('[data-vxof-qvok]');
    var schede   = {};
    var scrollBloccato = '';

    function chiudiScheda() {
      if (!qv) return;
      qv.hidden = true;
      document.body.style.overflow = scrollBloccato;
    }

    function disegnaScheda(c, dati2) {
      var foto = (dati2 && dati2.images && dati2.images.length ? dati2.images : [c.img])
        .slice(0, 6)
        .map(function (u) {
          var src = String(u).indexOf('//') === 0 ? 'https:' + u : u;
          return '<img src="' + src + '&width=700" alt="" loading="lazy" decoding="async">';
        }).join('');
      var prezzo = dati2 ? dati2.price : c.prezzo;
      var listino = dati2 ? (dati2.compare_at_price || 0) : c.listino;
      qvCorpo.innerHTML =
        '<div class="vxof__qvfoto">' + foto + '</div>' +
        '<h3 class="vxof__qvtitolo">' + c.titolo + '</h3>' +
        '<p class="vxof__qvmat">' + [c.materiale, c.colore].filter(Boolean).join(' · ') + '</p>' +
        '<p class="vxof__qvprezzo">' + euro(prezzo) +
          (listino > prezzo ? '<span class="vxof__qvbarrato">' + euro(listino) + '</span>' : '') +
        '</p>' +
        '<div class="vxof__qvtesto">' + ((dati2 && dati2.description) || '') + '</div>';
      qvCorpo.scrollTop = 0;
    }

    function apriScheda(c) {
      if (!qv || !qvCorpo) return;
      scrollBloccato = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      qv.hidden = false;
      disegnaScheda(c, schede[c.handle] || null);
      if (!c.handle || schede[c.handle]) return;
      fetch('/products/' + c.handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d) return;
          schede[c.handle] = d;
          if (!qv.hidden) disegnaScheda(c, d);
        })
        .catch(function () { /* resta la versione essenziale */ });
    }

    [].forEach.call(sezione.querySelectorAll('[data-vxof-qvchiudi]'), function (x) {
      x.addEventListener('click', chiudiScheda);
    });
    if (qvOk) qvOk.addEventListener('click', chiudiScheda);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && qv && !qv.hidden) chiudiScheda();
    });

    /* ---------------- acquisto ---------------- */
    if (compra) {
      compra.addEventListener('click', function () {
        if (errore) errore.hidden = true;
        if (!stato.principale) return;
        if (stato.opzione === 'coppia' && !stato.seconda) {
          if (errore) { errore.textContent = testo('err2', 'Scegli la seconda borsa per continuare.'); errore.hidden = false; }
          return;
        }
        if (stato.opzione === 'tris' && (!stato.seconda || !stato.terza)) {
          if (errore) { errore.textContent = testo('err3', 'Scegli la seconda e la terza borsa per continuare.'); errore.hidden = false; }
          return;
        }
        var righe = [{id: Number(stato.principale.id), quantity: 1}];
        if (stato.opzione === 'coppia' || stato.opzione === 'tris') righe.push({id: Number(stato.seconda.id), quantity: 1});
        if (stato.opzione === 'tris') {
          righe.push({id: Number(stato.terza.id), quantity: 1});
          /* La borsa in omaggio: la riconosce l'app dalla proprieta'
             _omaggio_bf (e dal prodotto). */
          var cT = contoTris();
          if (cT && cT.omaggio && stato.omaggio) {
            righe.push({id: Number(stato.omaggio.id), quantity: 1, properties: {_omaggio_bf: 'si'}});
          }
        }
        if (dati.omaggio && dati.omaggio.id) righe.push({id: Number(dati.omaggio.id), quantity: 1});

        compra.setAttribute('disabled', 'true');
        compra.textContent = testo('attesa', 'Un attimo…');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({items: righe})
        }).then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        }).then(function () {
          /* 30/09/2026 — se il cliente e' passato prima dalla landing dei
             199, quel codice e' rimasto attaccato alla sessione e al
             checkout farebbe pagare 199 invece del prezzo di questa
             pagina. Lo si toglie qui, prima di andare avanti: svuotare il
             carrello non basta, serve /cart/update.js con discount vuoto.
             La guardia generale fa lo stesso lavoro, ma qui si aspetta la
             risposta, cosi' non si corre contro il cambio di pagina. */
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({discount: ''})
          }).catch(function () {});
        }).then(function () {
          try { document.dispatchEvent(new CustomEvent('ARMADA:LOAD:CART', {detail: {}})); } catch (e) {}
          /* 15/10/2026 — con due borse il prezzo di questa pagina lo fa il suo
             codice (VOEMIP50, seconda borsa al 50%): lo sconto automatico del
             50% e' stato chiuso per la promo di Halloween. Si applica con il
             permalink dello sconto, come fa la landing dei 199. */
          var codice = (sezione.getAttribute('data-codice') || '').trim();
          if (codice && stato.opzione === 'coppia') {
            window.location.href = '/discount/' + encodeURIComponent(codice) + '?redirect=/checkout';
            return;
          }
          window.location.href = '/checkout';
        }).catch(function (err) {
          compra.removeAttribute('disabled');
          aggiorna();
          if (errore) {
            errore.textContent = testo('errore', 'Qualcosa non ha funzionato. Riprova o scrivici su WhatsApp.');
            errore.hidden = false;
          }
          if (window.console) console.warn('[vx-mip] aggiunta fallita:', err);
        });
      });
    }

    istanze.push({disegna: disegna, aggiorna: aggiorna});
    disegna();
    aggiorna();
  }

  function tuttiAggiornano() {
    istanze.forEach(function (i) { i.disegna(); i.aggiorna(); });
    annuncia();
  }

  function avvia() {
    [].forEach.call(document.querySelectorAll('[data-vxof]'), prepara);
    annuncia();
  }

  window.vxMipCompra = function () {
    var b = document.querySelector('[data-vxof-compra]');
    if (b) b.click();
  };

  if (document.readyState !== 'loading') { avvia(); }
  else { document.addEventListener('DOMContentLoaded', avvia); }
  document.addEventListener('shopify:section:load', avvia);
})();
